
<template>
  <div id="app" class="d-flex flex-column h-100">
    <nav-bar />
    <div class="container flex-grow-1">
      <error />
      <div class="mt-5">
        <transition
          enter-active-class="animate__animated animate__fadeIn animate__fast"
          leave-active-class="animate__animated animate__fadeOut animate__fast"
          mode="out-in">
          <router-view></router-view>
        </transition>
      </div>
    </div>
    <footer class="bg-light text-center p-3">
      <div class="logo"></div>
      <p>
        AltBit Limited
      </p>
    </footer>
  </div>
</template>

<script>
  import NavBar from "./components/NavBar";
  import Error from "./components/Error";
  import {eventBus} from "./main";

  export default {
    components: {
      NavBar,
      Error
    },
    created(){
      eventBus.$on('updateUser', (message) => {
        this.$store.dispatch('updateUser', message);
      });
      eventBus.$on('updateToken', (message) => {
        this.$store.dispatch('updateToken', message);
      });
      eventBus.$on('authError', (message) => {
        this.$store.dispatch('updateMessage', message);
      });
    }
  };
</script>